export default __webpack_public_path__ + "static/media/117.23c8dcb6.jpg";